import { render, staticRenderFns } from "./CandidatesComponent.vue?vue&type=template&id=38618393&scoped=true"
import script from "./CandidatesComponent.vue?vue&type=script&lang=js"
export * from "./CandidatesComponent.vue?vue&type=script&lang=js"
import style0 from "./CandidatesComponent.vue?vue&type=style&index=0&id=38618393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38618393",
  null
  
)

export default component.exports